export default __webpack_public_path__ + "5a06017ec6b43ec34a2cd8bde11f7a2b.png";